module.exports = __webpack_public_path__ + "img/acusticos.e68f75a0.jpg";